module.exports = __webpack_public_path__ + "static/media/Oracle.7e7b24c8.png";